import { merge } from 'lodash';
import { ControlPosition } from 'react-draggable';

import { usePersistState } from '../../../../hooks/usePersistState';

const STORAGE_KEY = 'draggableCardPositions';

export const useStoreCardPosition = (draggableCardKey: string) => {
  const [storedCardPosition, setStoredCardPosition] = usePersistState({}, STORAGE_KEY);

  const storeCardPosition = (userIdentifier: string, cardPosition: ControlPosition) => {
    setStoredCardPosition((currentCardPosition) => {
      const nextCardPositions = merge(
        { ...currentCardPosition },
        { [userIdentifier]: { [draggableCardKey]: { ...cardPosition } } },
      );

      return nextCardPositions;
    });
  };

  const removeCardPosition = (userIdentifier: string) => {
    setStoredCardPosition((currentCardPosition) => {
      const nextCardPositions = { ...currentCardPosition };
      delete nextCardPositions[userIdentifier][draggableCardKey];

      return nextCardPositions;
    });
  };

  const getCardPosition = (userIdentifier: string): ControlPosition => {
    const val = storedCardPosition?.[userIdentifier]?.[draggableCardKey];
    return val;
  };

  return {
    storeCardPosition,
    removeCardPosition,
    getCardPosition,
  };
};
